import { type FunctionComponent } from 'react';

import { URLS } from 'components/shared/App/constants';
import ListFilterButton from 'components/shared/ListFilterButton';

export interface SatNoteSignedButtonProps {
  active: boolean;
  toggleValue: (key: string) => void;
}

const SatNoteSignedButton: FunctionComponent<SatNoteSignedButtonProps> =
  function ({ active, toggleValue }) {
    return (
      <ListFilterButton
        id="sat-note-signed"
        active={active}
        label="Sat note signed"
        activeLabel="Sat note not signed"
        onClick={() => {
          toggleValue('satNoteSigned');
          window.location.href =
            URLS.jobsSatNoteSigned + (active ? '' : `?satNoteSigned=true`);
        }}
      />
    );
  };

export default SatNoteSignedButton;
